import { render, staticRenderFns } from "./DepIndex.vue?vue&type=template&id=5d5e85e8&scoped=true&"
import script from "./DepIndex.vue?vue&type=script&lang=js&"
export * from "./DepIndex.vue?vue&type=script&lang=js&"
import style0 from "./DepIndex.vue?vue&type=style&index=0&id=5d5e85e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e85e8",
  null
  
)

export default component.exports